import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LineAreaChartData } from '../../models/common.model';

@Component({
  selector: 'app-growth-metric-score-graph',
  templateUrl: './growth-metric-score-graph.component.html',
  styleUrls: ['./growth-metric-score-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrowthMetricScoreGraphComponent {
  @Input() growthMetricScoreGraph: LineAreaChartData;
}
